import { IGetVehicleInfo } from "api/interfaces/analytics.type";
import axios from "fetch-api/fetch-api";

export function getVehicleInfoApi(make: string, model: string, year: string) {
  return axios.get<IGetVehicleInfo>(`s/analytics/vehicle-attributes?make=${make}&model=${model}&year=${year}`);
}
